module.exports = __webpack_public_path__ + "site/img/avatar.6bde48dc.png";